module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-fill-minus-a5f48c11.svg";